import api from '@/api'

const state = {
  sensors: [],
  sensorReadings: {},
  loading: false,
  error: null
}

const mutations = {
  SET_SENSORS(state, sensors) {
    state.sensors = sensors
  },
  SET_SENSOR_READINGS(state, { sensorId, readings }) {
    state.sensorReadings = { ...state.sensorReadings, [sensorId]: readings }
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_ERROR(state) {
    state.error = null
  }
}

const actions = {
  async fetchSensors({ commit }) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const response = await api.get('/sensors')
      commit('SET_SENSORS', response.data)
    } catch (error) {
      commit('SET_ERROR', 'Error al cargar sensores')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchSensorReadings({ commit }, { sensorId, params = {} }) {
    try {
      const response = await api.get(`/sensors/${sensorId}/readings`, { params })
      commit('SET_SENSOR_READINGS', { sensorId, readings: response.data })
      return response.data
    } catch (error) {
      commit('SET_ERROR', 'Error al cargar lecturas del sensor')
      throw error
    }
  },

  async createSensor({ commit, dispatch }, sensorData) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      await api.post('/sensors', sensorData)
      await dispatch('fetchSensors')
      
      return { success: true }
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message || 'Error al crear sensor'
      commit('SET_ERROR', message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateSensor({ commit, dispatch }, { id, sensorData }) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      await api.put(`/sensors/${id}`, sensorData)
      await dispatch('fetchSensors')
      
      return { success: true }
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message || 'Error al actualizar sensor'
      commit('SET_ERROR', message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteSensor({ commit, dispatch }, id) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      await api.delete(`/sensors/${id}`)
      await dispatch('fetchSensors')
      
      return { success: true }
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message || 'Error al eliminar sensor'
      commit('SET_ERROR', message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async initialize({ dispatch }) {
    try {
      await dispatch('fetchSensors')
    } catch (error) {
      // Error initializing sensors module - handled silently
    }
  }
}

const getters = {
  sensors: state => state.sensors,
  sensorReadings: state => state.sensorReadings,
  loading: state => state.loading,
  error: state => state.error,
  
  activeSensors: state => state.sensors.filter(sensor => sensor.status === 'active'),
  offlineSensors: state => state.sensors.filter(sensor => sensor.status === 'offline'),
  
  getSensorById: state => id => {
    return state.sensors.find(sensor => sensor.id === id)
  },
  
  getSensorReadings: state => sensorId => {
    return state.sensorReadings[sensorId] || []
  },
  
  getSensorByDevice: state => deviceId => {
    return state.sensors.filter(sensor => sensor.deviceId === deviceId)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 


// WEBPACK FOOTER //
// ./src/store/modules/sensors.js